import { POSITION } from "@voltmoney/types";
import { ROUTE } from "../../../routes";
import { api, config } from "../../../configs/api";
import { APP_CONFIG, getAppHeader } from "../../../configs/config";
import { LENDER_ID } from "../../../configs/constants";
import { IconTokens, SizeTypeTokens, WIDGET } from "@voltmoney/schema";
import { Platform } from "react-native";
import { isIframe } from "../../payment/paymentStart/actions";
import { isFromAndroidWebview } from "../../../configs/utils";
export const leadToPayment = async (action, _datastore, { network, appendWidgets, openNewTab, removeWidgets, showPopup, setDatastore, goBack, navigate, }) => {
    const userContextResponse = await network.post(api.userContext, {}, { headers: await getAppHeader() });
    const userCreditId = userContextResponse.data.linkedCredits[0].creditId;
    let popupWindow;
    const lenderAccountId = userContextResponse.data.linkedApplications[0].lenderAccountId;
    let tataFlag = false;
    if (lenderAccountId.toLowerCase() === LENDER_ID.TATA.toLowerCase()) {
        const accountId = userContextResponse?.data.linkedApplications[0].accountId;
        const response = await network.get(`${api.isTataMergerEnabled}${accountId}`, { headers: await getAppHeader() });
        tataFlag = response?.data?.isEnabled;
    }
    await setDatastore(ROUTE.OUTSTANDING_DUES, "manageLimit", {
        loading: true
    });
    console.warn("PAYLOAD  RECEIVED IS", action.payload);
    await network.post(`${api.collectionNew}`, {
        collectionAmount: `${action.payload.amount}`,
        baseOriginUrl: `${config.APP_URL}`,
        creditId: userCreditId,
        redirect: Platform.OS === 'web' && !isIframe() && !isFromAndroidWebview() ? true : false,
        collectionType: `IN_APP_INTEREST_COLLECTION`
    }, { headers: await getAppHeader() })
        .then(res => {
        if (res.status === 200) {
            const isFromTata = userContextResponse.data.linkedApplications[0].lenderAccountId = "Tata";
            if (Platform.OS !== 'web') {
                appendWidgets(ROUTE.OUTSTANDING_DUES, {
                    repayLoanWebView: {
                        iframe: false,
                        uri: res.data.paymentLink
                    },
                    keyboardSpace: { size: SizeTypeTokens.XXXXXXL },
                    keyboardSpace2: { size: SizeTypeTokens.XXXXXXL },
                    keyboardSpace3: { size: SizeTypeTokens.XXXXXXL },
                    spaceXXL: { size: SizeTypeTokens.XXL }
                }, [
                    { id: "spaceXXL", type: WIDGET.SPACE },
                    { id: "repayLoanWebView", type: WIDGET.WEB_VIEW },
                    { id: "keyboardSpace", type: WIDGET.SPACE },
                    { id: "keyboardSpace2", type: WIDGET.SPACE },
                    { id: "keyboardSpace3", type: WIDGET.SPACE },
                ], "manageLimit");
                removeWidgets(ROUTE.OUTSTANDING_DUES, [
                    {
                        id: "manageLimit",
                        type: WIDGET.OUTSTANDING_DUES,
                    }
                ]);
                const runPollar = async () => {
                    network.get(`${api.userPaymentData}${res.data.collectionId}`, { headers: await getAppHeader(), routeName: "OUTSTANDING_DUES" }).then((response) => {
                        if (response.data.collectionStatus !== 'REQUESTED') {
                            clearInterval(timer);
                            removeWidgets(ROUTE.OUTSTANDING_DUES, [
                                { id: "repayLoanWebView", type: WIDGET.WEB_VIEW },
                                { id: "keyboardSpace", type: WIDGET.SPACE },
                                { id: "keyboardSpace2", type: WIDGET.SPACE },
                                { id: "keyboardSpace3", type: WIDGET.SPACE },
                                { id: "spaceXXL", type: WIDGET.SPACE }
                            ]);
                            navigate(ROUTE.PAYMENT_CALLBACK, { collectionId: response.data.collectionId });
                        }
                    });
                };
                const timer = setInterval(() => {
                    runPollar();
                }, APP_CONFIG.POLLING_INTERVAL);
            }
            else {
                if (isIframe() || isFromAndroidWebview()) {
                    showPopup({
                        isAutoTriggerCta: true,
                        type: 'DEFAULT',
                        iconName: IconTokens.Redirecting,
                        title: 'Waiting for response',
                        subTitle: 'Please wait while we process your request',
                        primary: false,
                    });
                    const url = res.data.paymentLink;
                    // Popup window size
                    const width = isFromTata ? 1002 : 504;
                    const height = 704;
                    // Calculate the position to center the popup on the screen
                    const left = (window.innerWidth - width) / 2;
                    const top = (window.innerHeight - height) / 2;
                    if (isFromAndroidWebview()) {
                        popupWindow = window.open(url, "_blank");
                    }
                    else {
                        popupWindow = window.open(url, "_blank", "width=" + width + ", height=" + height + ", top=" + top + ", left=" + left);
                    }
                }
                else {
                    if (isFromTata) {
                        const tataPaymentLink = res.data.paymentLink;
                        window.open(tataPaymentLink, "_self");
                        setDatastore(ROUTE.OUTSTANDING_DUES, "manageLimit", {
                            loading: false
                        });
                    }
                    else {
                        appendWidgets(ROUTE.PAYMENT_START, {
                            repayLoanWebView: {
                                iframe: Platform.OS === 'web',
                                uri: res.data.paymentLink
                            },
                            keyboardSpace: { size: SizeTypeTokens.XXXXXXL },
                            keyboardSpace2: { size: SizeTypeTokens.XXXXXXL },
                            keyboardSpace3: { size: SizeTypeTokens.XXXXXXL },
                        }, [
                            { id: "repayLoanWebView", type: WIDGET.WEB_VIEW },
                            { id: "keyboardSpace", type: WIDGET.SPACE },
                            { id: "keyboardSpace2", type: WIDGET.SPACE },
                            { id: "keyboardSpace3", type: WIDGET.SPACE },
                        ], "header");
                        removeWidgets(ROUTE.PAYMENT_START, [
                            {
                                id: "totalAmountShowStack",
                                type: WIDGET.CARD,
                                padding: {
                                    horizontal: 0,
                                    all: 0,
                                },
                                position: POSITION.ABSOLUTE_TOP,
                            },
                            {
                                id: "spaceLG",
                                type: WIDGET.SPACE
                            },
                            {
                                id: "titleStack",
                                type: WIDGET.STACK,
                            },
                            {
                                id: "spaceXXXL",
                                type: WIDGET.SPACE
                            },
                            {
                                id: "selectFullAmountStack",
                                type: WIDGET.STACK
                            },
                            {
                                id: "spaceXXXL",
                                type: WIDGET.SPACE
                            },
                            {
                                id: "divider",
                                type: WIDGET.DIVIDER
                            },
                            {
                                id: "partialAmountFullStack",
                                type: WIDGET.STACK
                            },
                            {
                                id: "proceedButtonStack",
                                type: WIDGET.STACK,
                                position: POSITION.ABSOLUTE_BOTTOM
                            },
                            {
                                id: "spaceLG",
                                type: WIDGET.SPACE
                            },
                            { id: "enterAmountFullStack", type: WIDGET.STACK },
                            { id: "amountMessage", type: WIDGET.TEXT }
                        ]);
                        setDatastore(action.routeId, "customHeader", {
                            title: (isFromTata)
                                ? (tataFlag
                                    ? "Paying to Tata Capital Limited"
                                    : "Paying to Tata Capital Financial Services Ltd.")
                                : "Paying to Bajaj Finance"
                        });
                    }
                }
                if (isIframe()) {
                    const runPollar = async () => {
                        network.get(`${api.userPaymentData}${res.data.collectionId}`, { headers: await getAppHeader(), routeName: "PAYMENT_START" }, async () => {
                            return;
                        }, {
                            disableDefault: true
                        }).then((response) => {
                            if (popupWindow.closed) {
                                goBack();
                                clearInterval(timer);
                            }
                            else {
                                if (response.data.collectionStatus === 'COLLECTION_COMPLETE' || response.data.collectionStatus === 'CANCELLED' || response.data.collectionStatus === 'FAILED') {
                                    removeWidgets(ROUTE.PAYMENT_START, [
                                        { id: "repayLoanWebView", type: WIDGET.WEB_VIEW },
                                        { id: "keyboardSpace", type: WIDGET.SPACE },
                                        { id: "keyboardSpace2", type: WIDGET.SPACE },
                                        { id: "keyboardSpace3", type: WIDGET.SPACE },
                                    ]);
                                    clearInterval(timer);
                                    if (popupWindow) {
                                        popupWindow.close(); // Close the popup window if it exists
                                    }
                                    navigate(ROUTE.PAYMENT_CALLBACK, { collectionId: response.data.collectionId });
                                }
                            }
                        });
                    };
                    const timer = setInterval(() => {
                        runPollar();
                    }, APP_CONFIG.POLLING_INTERVAL);
                }
            }
        }
        else {
            setDatastore(ROUTE.OUTSTANDING_DUES, "manageLimit", {
                loading: false
            });
        }
    });
};
export const goBack = async (action, _datastore, { navigate, goBack }) => {
    await goBack();
};
export const needHelp = async (action, _datastore, { navigate }) => {
    await navigate(ROUTE.CONTACT_US_CARD);
};
